import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    enabled: true,
    phone: "6282228886906",
    title: "help.defaultTitle",
    message: "help.defaultContent",
    whatsappText: "Hello TruCarbon, I have questions about your services."
};

const helpFabSlice = createSlice({
    name: "helpFab",
    initialState,
    reducers: {
        setFabMessage: (state, action) => {
            const p = action.payload || {};
            if ("title" in p)   state.title   = p.title ?? "";
            if ("message" in p) state.message = p.message ?? "";
            if ("whatsappText" in p) state.whatsappText = p.whatsappText ?? "";
        },
        clearFabMessage: (state) => {
            state.title = initialState.title;
            state.message = initialState.message;
            state.whatsappText = initialState.whatsappText;
        },
        setFabEnabled: (state, action) => { state.enabled = !!action.payload; },
    },
});

export const { setFabMessage, clearFabMessage, setFabEnabled } = helpFabSlice.actions;
export const selectHelpFab = (s) => s?.helpFab ?? initialState;
export default helpFabSlice.reducer;
